export const LINK_LABELS = {
  HOME: 'Home',
  PROFILE: 'My profile',
  ABOUT_US: 'About Us',
  CONTACT_US: 'Contact Us',
  DOCUMENTS: 'My documents',
};
